import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import { AppContext } from "../App";
import { fbdb } from "../AppClass";

import { FetchData } from "../services/FetchData";
import { TextField } from "@material-ui/core";

class MyDialog extends React.Component {
  state = {
    meaning_added: "" 
  };

  handleClickOpen = () => {
    //this.setState({ meaning_added: true });
  };

  handleClose = action => {
    this.setState({ meaning_added: "" });
    action.dialogOpenClose(false);
  };

  render() {
    return (
      <AppContext.Consumer>
        {({ state, actions }) => (
          <div>
            <Dialog
              open={state.dialogOpen}
              onClose={() => this.handleClose(actions)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth
            >
              <DialogTitle id="alert-dialog-title">
                Add to dictionary
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span className="redUnderline">{state.clickedWord}</span> -
                  Submit if word is correct.
                </DialogContentText>
                <TextField
                  label="Add meaning (optional)"
                  margin="normal"
                  variant="filled"
                  fullWidth={true}
                  onChange={(e) => this.setState({meaning_added: e.currentTarget.value})}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => this.handleClose(actions)}
                  color="primary"
                >
                  cancel
                </Button>
                <Button
                  onClick={() => {
                    this.handleClose(actions);

                    const auth_token = localStorage.getItem("auth_token");
                    const user_name = localStorage.getItem("user_name");

                    // fbdb
                    //   .collection("words")
                    //   .add({
                    //     id: auth_token,
                    //     words: [state.clickedWord]
                    //   })
                    //   .then(function(docRef) {
                    //     console.log("Document written with ID: ", docRef.id);
                    //     actions.openSnackBar("Word submitted successfully.");

                    //     //self.setState({ submitting: false });
                    //   })
                    //   .catch(function(error) {
                    //     console.error("Error adding document: ", error);
                    //     //actions.setState({ submitting: false });
                    //   });

                    FetchData("/add_word", {
                      id: auth_token,
                      name: user_name,
                      word: state.clickedWord,
                      suggested_word: this.state.meaning_added,
                      action: "add_dict"
                    })
                      .then(result => {
                        if (result === "exists") {
                          actions.openSnackBar(
                            "Word's already under verification process."
                          );
                        } else if (result === "added") {
                          actions.openSnackBar("Word submitted successfully.");
                        }
                      })
                      .catch(error => {
                        //alert(error);
                      });
                  }}
                  color="primary"
                  autoFocus
                >
                  submit
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        )}
      </AppContext.Consumer>
    );
  }
}

export default MyDialog;
